import { EventMessage } from '@/common/analytics/gtm/types';
import { getOrCreateAthenaUserIdCookie } from '@/common/athena/checkAndSetAthenaCookie';

export const createArtworkEventContext = (eventMessage: EventMessage) => {
  const athenaUserId = getOrCreateAthenaUserIdCookie();

  const {
    message: { index, externalId },
    metadata: { athenaPageName },
  } = eventMessage;
  return {
    name: athenaPageName,
    impressionId: `${index + 1}_${externalId}_${athenaUserId}`,
  };
};

export const createEmptyArtworkContext = (
  athenaPageName: string,
): {
  name: string;
  impressionId: null;
} => {
  return {
    // TODO: athena context name property will be unified for pdp, CONR-2663
    name: athenaPageName === 'artwork' ? 'product' : athenaPageName,
    impressionId: null,
  };
};
